import * as React from 'react';
import CheckMarkIcon from '@narvar/nth-bit-icon-check-mark';
import { Column, Row } from '@narvar/nth-grid';
import {
  useTranslations,
  withTranslationsProvider,
} from '@narvar/nth-hook-translations';
import PanelContentHeader from '@narvar/nth-block-panel-content-header';
import { useDeliveryInstructionsContext } from '../../hooks/useDeliveryInstructionsState';
import CustomComponentContext from '../CustomComponentContext';

const SubmitDeliveryInstructionsSuccessPanel: React.FunctionComponent = () => {
  const {
    state: { registerAccount },
  } = useDeliveryInstructionsContext();
  const { state } = React.useContext(CustomComponentContext);
  const { featureName } = state?.settings || { featureName: '' };

  const {
    deliveryInstructionsSubmitSuccessText,
    deliveryInstructionsSubmitMyChoiceSuccessText,
  } = useTranslations();

  const headerText =
    (registerAccount
      ? deliveryInstructionsSubmitMyChoiceSuccessText
      : deliveryInstructionsSubmitSuccessText) || '';

  const featureNameData = typeof featureName === 'string' ? featureName : '';

  return (
    <div style={{ padding: '0.25rem 0' }}>
      <Row>
        <Column xs-style="display: block;" sm-style="display: none">
          <PanelContentHeader
            as="h2"
            icon={<CheckMarkIcon />}
            featureName={featureNameData}
            headerText={headerText}
            paragraphChildren=""
          />
        </Column>
        <Column xs-style="display: none;" sm-style="display: block;">
          <PanelContentHeader
            as="h2"
            icon={<CheckMarkIcon />}
            featureName={featureNameData}
            headerText={headerText}
            paragraphChildren=""
            isLandscape
          />
        </Column>
      </Row>
    </div>
  );
};

export default withTranslationsProvider(
  SubmitDeliveryInstructionsSuccessPanel,
  {
    translationKeys: [
      'deliveryInstructionsSubmitSuccessText',
      'deliveryInstructionsSubmitMyChoiceSuccessText',
    ],
  },
);
